import styled from 'styled-components';

const OutermostContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const TextContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const Text = styled.h6`
	color: black;
	margin: 0px;
`;

const BarContainer = styled.div`
	display: flex;
	height: 6px;
	width: 100%;
	border-radius: 12px;
	background-color: rgba(158, 158, 158, 0.2);
`;

const ProgressIndicator = styled.div`
	display: flex;
	margin-left: ${(props) =>
		props?.isCountdown ? props.progress.toString() + '%' : (props.progress - 2).toString() + '%'};
	width: ${(props) => (props?.isCountdown ? '100%' : '6px')};
	background-color: ${(props) => {
		if (100 - props?.progress < 40) {
			if (100 - props?.progress < 20) {
				return 'rgba(239, 83, 80, 0.4)';
			} else {
				return 'rgba(255, 152, 0, 0.4)';
			}
		} else {
			return 'rgba(76, 175, 80, 0.4)';
		}
	}};
`;

const ReviewProgressIndicator = styled.div`
	display: flex;
	margin-left: ${(props) =>
		props?.isCountdown ? props.progress.toString() + '%' : (props.progress - 2).toString() + '%'};
	width: ${(props) => (props?.isCountdown ? '100%' : '6px')};
	background-color: ${(props) => {
		if (props.isExpired) {
			return '#edafae';
		} else {
			if (props.progress >= 50) {
				return '#f4ca8e';
			} else {
				return 'rgba(76, 175, 80, 0.4)';
			}
		}
	}};
`;

export default {
	OutermostContainer,
	TextContainer,
	Text,
	BarContainer,
	ProgressIndicator,
	ReviewProgressIndicator
};
